const ScrollTop = () => {
  window.scrollTo({
    top: 0,
    left: 0,
  });
};
export default ScrollTop;
